import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueHead from 'vue-head'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$api = process.env.NODE_ENV === 'production' ? '/api' : 'https://otagomuseum.nz/api';
//Vue.prototype.$api = 'http://localhost/api';
Vue.prototype.$eventBus = new Vue();


Vue.use(VueHead);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
